export const BinState = Object.freeze({
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  UNKNOWN: 'unknown',
});

export const BinStateColour = Object.freeze({
  [BinState.ERROR]: '#c93624', // Red 900
  [BinState.WARNING]: '#eee276', // Yellow 600
  [BinState.SUCCESS]: '#188A47', // Green 800
  [BinState.UNKNOWN]: '#9ca3af', // Grey 400
});

export const OrderState = Object.freeze({
  RECOMMENDED: 'recommended',
  SHIPPED: 'shipped',
  SCHEDULED: 'ordered',
  DELIVERED: 'delivered',
});

export const OrderStateString = Object.freeze({
  [OrderState.RECOMMENDED]: 'Order Recommended for',
  [OrderState.SHIPPED]: 'Order Shipped on',
  [OrderState.SCHEDULED]: 'Order Scheduled for',
  [OrderState.DELIVERED]: 'Order Delivered on',
});
